import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseService } from '../base/base.service';
import { environment } from '../../../environments/environment';
import { MessagesModel } from '../../models/messages/messages.model';

@Injectable({
  providedIn: 'root'
})
export class MessagesService extends BaseService<MessagesModel> {
  hasUnreadMessagesChanges = new BehaviorSubject<boolean>(null);
  constructor(protected http: HttpClient) {
    super(http, 'messages');
  }

  batchDelete(ids) {
    return this.http.post(`${environment.api_url}/messages/batch-delete`, ids, {
      observe: 'response'
    });
  }

  countUnreadMessages() {
    this.http
      .get<{ data: number }>(`${environment.api_url}/messages/unread-count`, {
        observe: 'response'
      })
      .subscribe(res => {
        this.hasUnreadMessagesChanges.next(res.body && res.body.data !== 0);
      });
  }
}
